import * as actionTypes from "./actionTypes";

//SWIFT DAY
const swiftDayInitialState = {
  processing: false,
  loadingMessages: false,
  sendingMail: false,
  messages: null,
  currentBic: null,
  bankBics: null,
  currentMessageStatus: null,
  currentType: null,
  currentTypeMessages: null,
  currentMessage: null,
  currentMessageIndex: null,
  messagesCount: null,
  messageDetails: null,
  messageTreeDetails: null,
  bankLogoURL: null,
};

export const swiftDayReducer = (state = swiftDayInitialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.RESET_SWIFT_DAY:
      return swiftDayInitialState;
    case actionTypes.SET_PROCESSING_SWIFT_DAY:
      return { ...state, processing: true };
    case actionTypes.STOP_PROCESSING_SWIFT_DAY:
      return { ...state, processing: false };
    case actionTypes.LOAD_CORZAP_MESSAGES:
      return {
        ...state,
        loadingMessages: payload,
      };
    case actionTypes.SENDING_MAIL:
      return {
        ...state,
        sendingMail: payload,
      };
    case actionTypes.GET_CORZAP_MESSAGES:
      return {
        ...state,
        messages: payload,
        currentBic: payload?.bankBics?.length ? payload.bankBics[0] : null,
        bankBics: payload
          ? payload.bankBics.filter((bic) => bic.messageTypesCount > 0)
          : null,
        currentMessageStatus: payload?.bankBics?.length
          ? payload.bankBics[0].messageStatuses[0].name
          : null,
        loadingMessages: false,
      };

    case actionTypes.SET_CURRENT_BIC:
      return {
        ...state,
        currentBic: state.bankBics?.find((bankBic) => bankBic.bic === payload),
      };

    case actionTypes.SET_CURRENT_MESSAGE_STATUS:
      return {
        ...state,
        currentMessageStatus: payload,
      };

    case actionTypes.SET_CURRENT_TYPE:
      const bic = state.bankBics?.find(
        (bankBic) => bankBic.bic === payload.bic
      );

      const messages = bic.messageStatuses
        .find((status) => status.name === payload.messageStatus)
        .messagesTypes.find((type) => type.type === payload.type).messages;

      const filteredMessages = [];

      [...messages].forEach((message) => {
        const index = filteredMessages.findIndex(
          (mess) =>
            message.header.referenceNumber === mess.header.referenceNumber
        );
        if (index === -1) filteredMessages.push(message);
      });

      return {
        ...state,
        currentType: payload.type,
        currentTypeMessages: filteredMessages,
        messagesCount: filteredMessages.length,
        currentMessage: null,
        currentMessageIndex: null,
        currentBic: bic,
        currentMessageStatus: payload.messageStatus,
      };

    case actionTypes.FILTER_CURRENT_TYPE_MESSAGES:
      let filtered = [];
      const allMessages = state.currentBic.messageStatuses
        .find((status) => status.name === state.currentMessageStatus)
        .messagesTypes.find((type) => type.type === state.currentType).messages;

      if (payload.length) {
        const filtersHashMap = {};

        payload.forEach((filter) => {
          if (filtersHashMap[filter.category])
            filtersHashMap[filter.category].push(filter.value);
          else filtersHashMap[filter.category] = [filter.value];
        });

        allMessages.forEach((message) => {
          let add = [];
          Object.keys(filtersHashMap).forEach((cat) => {
            if (filtersHashMap[cat].includes(message.header.filters[cat]))
              add.push(true);
            else add.push(false);
          });
          if (!add.includes(false)) filtered.push(message);
        });
      } else {
        filtered = allMessages;
      }
      const cleanMessages = [];

      [...filtered].forEach((message) => {
        const index = cleanMessages.findIndex(
          (mess) =>
            message.header.referenceNumber === mess.header.referenceNumber
        );
        if (index === -1) cleanMessages.push(message);
      });

      return {
        ...state,
        currentTypeMessages: cleanMessages,
        messagesCount: cleanMessages.length,
        currentMessage: null,
        currentMessageIndex: null,
      };

    case actionTypes.SET_CURRENT_MESSAGE:
      const message = payload
        ? state.currentTypeMessages.find(
            (message) => message.header.referenceNumber === payload
          )
        : null;

      // const message = state.currentTypeMessages[0];

      const messageIndex = message
        ? state.currentTypeMessages.findIndex(
            (message) => message.header.referenceNumber === payload
          )
        : null;

      // const messageIndex = 0;

      let messageDetails = payload ? [] : null;
      let messageTreeDetails = payload ? [] : null;

      if (payload) {
        //remove duplicate details
        const details = [];
        [...message.detail.details].forEach((detail) => {
          const index = details.findIndex(
            (messageDetail) => messageDetail.title === detail.title
          );
          if (index === -1) details.push(detail);
        });

        const sendingDateTime =
          message.detail.header.sendingDateTime?.split(" ");

        messageDetails = [
          {
            title: message.detail.header.title,
            data: [
              { key: "Category", value: message.detail.header.category },
              { key: "Type", value: message.detail.header.messageType },
              { key: "Way", value: message.detail.header.messageStatus },
              ...(message.detail.header.uetr
                ? [
                    {
                      key: "uetr",
                      value: message.detail.header.uetr,
                    },
                  ]
                : []),

              ...(message.detail.header.sessionNumber
                ? [
                    {
                      key: "Session Number",
                      value: message.detail.header.sessionNumber,
                    },
                  ]
                : []),

              ...(message.detail.header.sequenceNumber
                ? [
                    {
                      key: "Sequence Number",
                      value: message.detail.header.sequenceNumber,
                    },
                  ]
                : []),

              ...(sendingDateTime
                ? [
                    {
                      key: "Sending Date",
                      value: sendingDateTime[0],
                    },
                    {
                      key: "Sending Time",
                      value: sendingDateTime[1],
                    },
                  ]
                : []),
            ],
            fieldKey: "",
          },
          ...(message.detail.header.senderBic
            ? [
                {
                  title: "Sender BIC",
                  data: [
                    { key: "BIC", value: message.detail.header.senderBic },
                  ],
                  fieldKey: "",
                },
              ]
            : []),
          ...(message.detail.header.receiverBic
            ? [
                {
                  title: "Reciever BIC",
                  data: [
                    { key: "BIC", value: message.detail.header.receiverBic },
                  ],
                  fieldKey: "",
                },
              ]
            : []),
          ...details.sort((a, b) => a.fieldKey.localeCompare(b.fieldKey)),
        ];

        messageTreeDetails = message.detail.treeDetails;
      }

      return {
        ...state,
        currentMessage: message,
        currentMessageIndex: messageIndex,
        messageDetails: messageDetails,
        messageTreeDetails: messageTreeDetails,
      };

    case actionTypes.SET_BANK_LOGO_URL: {
      return {
        ...state,
        bankLogoURL: payload,
      };
    }

    default:
      return state;
  }
};

// SWIFT Messages

const swiftMessagesInitialState = {
  processing: false,
  rows: [],
  filterMX: "MT",
  filterMessageType: [],
  pageSize: 10,
  pageNumber: 1,
  totalItems: 0,
  totalPages: 0,
  updatedAt: new Date(),
  countries: {
    items: [],
  },
  currencies: {
    items: [],
  },
  messageTypes: {
    items: [],
  },
  fieldNames: {
    items: [],
  },
};

export const swiftMessagesReducer = (
  state = swiftMessagesInitialState,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.RESET_SWIFT_MESSAGES:
      return swiftMessagesInitialState;
    case actionTypes.SET_PROCESSING_SWIFT_MESSAGES:
      return { ...state, processing: true };
    case actionTypes.STOP_PROCESSING_SWIFT_MESSAGES:
      return { ...state, processing: false };
    case actionTypes.SEARCH_SWIFT_MESSAGES:
      return payload
        ? {
            ...state,
            rows: [...payload.returnResult],
            totalItems: payload.totalItems,
            totalPages: payload.totalPages,
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            updatedAt: new Date(),
            processing: false,
          }
        : { ...state, processing: false };
    case actionTypes.LOAD_COUNTRIES:
      return {
        ...state,
        countries: {
          items: payload ? [...payload.returnObject] : state.countries.items,
        },
      };
    case actionTypes.LOAD_CURRENCIES:
      return {
        ...state,
        currencies: {
          items: payload ? [...payload.returnObject] : state.currencies.items,
        },
      };

    case "FILTER_MX":
      const messageTypeByMX =
        state.filterMX !== "MX"
          ? state.filterMessageType.filter((item) => !item.isMT)
          : state.filterMessageType.filter((item) => item.isMT);
      return {
        ...state,
        filterMX: payload,
        fieldNames: {
          items: [],
        },
        messageTypes: {
          items: messageTypeByMX,
        },
      };
    case actionTypes.LOAD_MESSAGE_TYPES:
      return {
        ...state,
        filterMessageType: payload
          ? [...payload.returnObject]
          : state.messageTypes.items,
        messageTypes: {
          items: payload
            ? [...payload.returnObject.filter((item) => item.isMT)]
            : state.messageTypes.items,
        },
      };
    case actionTypes.LOAD_FIELD_NAMES:
      return {
        ...state,
        fieldNames: {
          items: payload ? [...payload.returnObject] : state.fieldNames.items,
        },
      };

    case actionTypes.SET_BANK_LOGO_URL: {
      return {
        ...state,
        bankLogoURL: payload,
      };
    }

    default:
      return state;
  }
};
